import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { createFocusRingStyles } from "../../../../util/createFocusRingStyles";
import { withFocusToggleClassName } from "../../../../util/withFocusClassName";
import { formInputTheme } from "../../../textinput/styled/formInputTheme";
import { selectV2Theme } from "../selectV2Theme";
export var Root = withFocusToggleClassName(styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n\n    // To allow certain elements within here to use z-index without breaking stacking context.\n    isolation: isolate;\n\n    // Calling this out explicitly so people notice.\n    /* box-sizing: content-box; */\n    box-sizing: border-box;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    min-height: 40px;\n\n    background-color: ", ";\n\n    border-radius: ", ";\n\n    ", "\n\n    // We're going to use a second ring here to fake the border. Doing this allows us to avoid a lot\n    // of positioning issues due to the border width changes necessary for Ursa. Since there are a\n    // number of elements that add some margin-top, left, top, etc., they all need to be adjusted\n    // when validationState changes in Ursa. Lodestar doesn't have this problem. Using this method,\n    // this \"border\" will overlay the outer edge of the SelectV2 and inner elements will be\n    // positioned against the outer edge of the root element which now has no actual border.\n    ", "\n\n    ", "\n    \n    ", "\n    \n    ", "\n"])), getBackgroundColor, function (_ref) {
  var themeMode = _ref.themeMode;
  return formInputTheme.borderRadius(themeMode);
}, function (_ref2) {
  var isFocused = _ref2.isFocused,
    omitFocusRing = _ref2.omitFocusRing,
    themeMode = _ref2.themeMode;
  return isFocused && !omitFocusRing && formInputTheme.focusRing.enabled(themeMode) ? createFocusRingStyles({
    theme: themeMode,
    gap: 1,
    // This is kinda weird, but by using an empty string here, we defer the show/hide
    // behavior to the ternary statement above.
    focusSelector: "",
    componentBorderWidth: 0,
    componentRadius: formInputTheme.borderRadius(themeMode)
  }) : "";
}, function (props) {
  return createFocusRingStyles({
    theme: props.themeMode,
    gap: -formInputTheme.borderWidth[props.validationState](props.themeMode),
    // Always show this ring.
    focusSelector: "",
    componentBorderWidth: 0,
    componentRadius: formInputTheme.borderRadius(props.themeMode),
    innerColorOverride: "transparent",
    colorOverride: getBorderColor(props),
    ringWidth: getBorderWidth(props),
    pseudoElement: "after"
  });
}, function (props) {
  return props.appearance === "underlined" && "\n        // specific styles for the underlined appearance's focus ring\n        &::before {\n            // Needed to ensure the focus ring and white offset ring cover the underline\n            z-index: 1;\n        }\n\n        // specific styles for the underlined appearance's \"border\"\n        &::after {\n            // this overrides the border width set in createFocusRingStyles\n            border-width: 0;\n            border-radius: 0;\n            ".concat(getBorderRule(props), "-width: ").concat(getBorderWidth(props), "px;\n\n            ").concat(props.isFocused ? "\n                        // to hide the tiny triangle sliver of underline peeking out in Ursa\n                        right: ".concat(selectV2Theme.border.focusedInset(props.themeMode), ";\n                        left: ").concat(selectV2Theme.border.focusedInset(props.themeMode), ";\n                        // For Lodestar flat underline but rounded focus ring\n                        border-radius: ").concat(selectV2Theme.border.focusedRadius(props.themeMode), ";\n                    ") : "", "\n        }\n        ");
}, function (props) {
  return props.appearance === "borderless" && (formInputTheme.focusRing.enabled(props.themeMode) || !props.isFocused) && "\n            &::after {\n                border: none;\n            }\n        ";
}, function (_ref3) {
  var isFocused = _ref3.isFocused,
    themeMode = _ref3.themeMode,
    validationState = _ref3.validationState;
  if (!isFocused && validationState === "rest") {
    return "\n                &:hover:after {\n                    border-color: ".concat(formInputTheme.borderColor.hover(themeMode), ";\n                }\n            ");
  }
}));
function getBorderWidth(_ref4) {
  var themeMode = _ref4.themeMode,
    validationState = _ref4.validationState;
  if (validationState === "error") {
    return formInputTheme.borderWidth.error(themeMode);
  } else {
    return formInputTheme.borderWidth.rest(themeMode);
  }
}
function getBackgroundColor(_ref5) {
  var isReadonly = _ref5.isReadonly,
    themeMode = _ref5.themeMode,
    validationState = _ref5.validationState,
    appearance = _ref5.appearance;
  if (appearance === "underlined") {
    return formInputTheme.backgroundColor.underlined(themeMode);
  }
  if (isReadonly) {
    return formInputTheme.backgroundColor.readonly(themeMode);
  } else if (validationState === "error") {
    return formInputTheme.backgroundColor.error(themeMode);
  } else {
    return formInputTheme.backgroundColor.rest(themeMode);
  }
}
function getBorderColor(_ref6) {
  var isFocused = _ref6.isFocused,
    themeMode = _ref6.themeMode,
    validationState = _ref6.validationState;
  if (validationState === "error" && isFocused) {
    return formInputTheme.borderColor.errorFocus(themeMode);
  } else if (validationState === "error") {
    return formInputTheme.borderColor.error(themeMode);
  } else if (isFocused) {
    return formInputTheme.borderColor.focus(themeMode);
  } else {
    return formInputTheme.borderColor.rest(themeMode);
  }
}
function getBorderRule(_ref7) {
  var appearance = _ref7.appearance,
    isFocused = _ref7.isFocused,
    themeMode = _ref7.themeMode;
  return appearance === "underlined" && !isFocused ? "border-bottom" : appearance === "underlined" ? selectV2Theme.border.focusedRule(themeMode) : "border";
}
//# sourceMappingURL=Root.js.map